import React from 'react';
import CollectRawDataComponent from './CollectRawDataComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getModel } from './selectors';
import * as actions from './actions';

const CollectRawDataContainer = (props) => {
    return <CollectRawDataComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const CollectRawDataContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(CollectRawDataContainer);

export default CollectRawDataContainerConn;
